import React from 'react';
import ImageUpload from './components/ImageUpload';
import MasonryGrid from './components/MasonryGrid';
import NotificationSystem from './components/NotificationSystem';
import { useInfiniteScroll } from './hooks/useInfiniteScroll';
import './App.css';

// main app component
function App() {
  const {
    allImages,
    displayedImages,
    loading,
    hasMore,
    userImageCount,
    addNewImages,
    loadMore
  } = useInfiniteScroll();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-200">
      <NotificationSystem />

      {/* header */}
      <header className="bg-white shadow-sm sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            ImageFlow
          </h1>
          <div className="flex items-center gap-4 mr-12">
            {userImageCount > 0 && <span className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded-full">{userImageCount} saved</span>}
            <span className="text-sm text-gray-500">
              {displayedImages.length} of {allImages.length}+ images
            </span>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-8">
        <ImageUpload onPublish={addNewImages} />
        <MasonryGrid
          images={displayedImages}
          onLoadMore={loadMore}
          hasMore={hasMore}
          loading={loading}
        />
      </main>

      <footer className="bg-white border-t mt-12 py-6 text-center text-gray-400 text-sm">
        ImageFlow - Upload and share your images
      </footer>
    </div>
  );
}

export default App;
